import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import {
  primaryJointInsert,
  primaryJointList,
  primaryJointUpdate,
} from "../../../Redux/Actions";
import usePermissions from "../../Common/Functions/usePermissions";

const PrimaryJointForm = () => {
  const dispatch = useDispatch();
  const { primaryJointSingle } = useSelector((state) => state.PrimaryJoint);
  // Permissions
  const addPermission = usePermissions(Constants.permission.BODY_PART_ADD);
  const editPermission = usePermissions(Constants.permission.BODY_PART_EDIT);

  // Initial values to Joint form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });

  // Validations for Joint form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill body group form
    if (primaryJointSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (primaryJointSingle[key]) {
          editValue[key] = primaryJointSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [primaryJointSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update primary joint API
        let submitFunc = primaryJointInsert(values);
        if (primaryJointSingle._id) {
          values.id = primaryJointSingle._id;
          submitFunc = primaryJointUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.PRIMARY_JOINT_SINGLE, payload: "" });
            dispatch({ type: types.PRIMARY_JOINT_FORM_MODEL, payload: "" });
          }
          dispatch(primaryJointList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !primaryJointSingle?._id) ||
            (editPermission && primaryJointSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default PrimaryJointForm;
